


export class BrowserAppEvaluationToolInfo {

  public version = '2024.4.19.1';

  constructor() {
  }

}
